// TAPINTO® Editor Frontend - Editor Page
// Version: 1.0
// Date: 2025-10-01

import React from 'react';
import { useParams } from 'react-router-dom';
import { EditorCanvas } from '../components/editor/EditorCanvas';

export function EditorPage() {
  const { pageId } = useParams<{ pageId: string }>();

  if (!pageId) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-neutral-900 mb-2">
            Page Not Found
          </h1>
          <p className="text-neutral-600">
            The requested page could not be found.
          </p>
        </div>
      </div>
    );
  }

  return <EditorCanvas pageId={pageId} />;
}
